import {mapActions} from 'vuex'

const EventBus = window.VueEventBus

export default {
  name: 're-cart-error',
  mixins: [],
  props: {
    error: {

    },
    askToSignIn: {

    },
    errorContainerClass: {
      type: [String, Array, Object],
      default: ''
    },
    loginUri: {
      type: [String, Object],
      default: '/sign-in'
    },
    loginText: {
      type: String,
      default: 'Sign In'
    },
    registerUri: {
      type: [String, Object],
      default: '/register'
    },
    registerText: {
      type: String,
      default: 'Register'
    }
  },

  data() {
    return {
    }
  },

  created() {
  },

  computed: {
    needsToSignIn() {
      return this.askToSignIn
    },
    errorMessage() {
      return this.error
    }
  },

  methods: {
    ...mapActions(['rememberAfterLoginRoute']),

    storeAfterLoginRedirect() {
      EventBus.$emit('cart-error.set-post-login-page', 'page-checkout')
      this.rememberAfterLoginRoute({ route: 'cart', expires: 1 })
    },
  },
}
